import { Routes } from '@front-app/constants/routes';
import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { PhoenixRouteConfig } from '../Model';
import { getSingleParam } from '../util/getFromRequest';
import { login } from './login/login';

export const publicRoutes: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('page.title.activate-your-account') as string;
			},
			isPublic: true,
		},
		path: '/activate/error',
		name: Routes.ACTIVATION_ERROR,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				email: route.query.email || '',
			};
		},
		component: () => import(/* webpackChunkName: "accountActivation" */ '@front-app/views/accountActivation/ActivationError.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('page.title.activate-your-account') as string;
			},
			isPublic: true,
		},
		path: '/activate/already',
		name: Routes.ACTIVATION_ALREADY_ACTIVATED,
		component: () => import(/* webpackChunkName: "accountActivation" */ '@front-app/views/accountActivation/ActivationAlreadyActivated.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('page.title.activate-your-account') as string;
			},
			isPublic: true,
		},
		path: '/activate/required',
		name: Routes.ACTIVATION_REQUIRED,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				email: getSingleParam(route.query.email),
			};
		},
		component: () => import(/* webpackChunkName: "accountActivation" */ '@front-app/views/accountActivation/ActivationRequired.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('page.title.activate-your-account') as string;
			},
		},
		path: '/activate/success',
		name: Routes.ACTIVATION_SUCCESS,
		component: () => import(/* webpackChunkName: "accountActivation" */ '@front-app/views/accountActivation/ActivationSuccess.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('invitations.decline-invitation') as string;
			},
			isPublic: true,
		},
		path: '/invitations/decline',
		name: Routes.INVITATION_DECLINE,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				email: getSingleParam(route.query.email),
				inviteId: route.query.inviteId,
				groupId: route.query.groupId,
			};
		},
		component: () => import(/* webpackChunkName: "declineInvitation" */ '@front-app/views/invitations/DeclineInvitation.vue'),
	},
	...login,
];
